module.exports = __webpack_public_path__ + "static/media/HomeEanpayMoneyTransfer.8ebce806.svg";